import { makeURL } from '../helperFunctions';

export const surveyCardText = {
    brandPersona: {
        icon: makeURL("/images/brand-persona-research-image.png"),
        titlePrimary: "Brand Persona",
        bodyPrimary: "Develop your own unique brand personality by giving a set of human characteristics to your brand. Brand persona is humanized representation of your brand’s values, benefits, and image.",
        bodySecondary: "Why just make one, develop a custom brand persona for each market segment you target."
    },
    buyerPersona: {
        icon: makeURL("/images/buyer-persona-research-image.png"),
        titlePrimary: "Audience Persona",
        bodyPrimary: "Create a clear, humanized profile of your ideal customer. An audience persona captures who they are, what they value, and how they make purchase decisions.",
        bodySecondary: "Build separate audience personas for each target segment to ensure your messaging and strategy align with the right audience."
    },
    surveyPost: {
        icon: makeURL("/images/survey-post-research-image.png"),
        titlePrimary: "Marketing Strategy",
        titleSecondary: "Impact Analysis",
        bodyPrimary: "Marketing Strategy Impact Analysis allows you to test your marketing campaigns before they are posted.",
        bodySecondary: "Evaluate how different campaigns would be perceived by different market segments and receive recommendations on whether you should proceed with your campaigns."
    }
};
